import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { DOMAIN_FOR_DOWNLOAD_TAGS_FRAGMENT } from './fragment'
import { Data, Variables } from './types'

export const GET_DOMAINS_FOR_DOWNLOAD_TAGS: TypedDocumentNode<Data, Variables> = gql`
  ${DOMAIN_FOR_DOWNLOAD_TAGS_FRAGMENT}

  query getDomainsForDownloadTags(
    $workspaceId: ID!
    $first: Int
    $last: Int
    $terms: [String!]
    $sort: DomainSortInput
  ) {
    domains(workspaceId: $workspaceId, first: $first, last: $last, terms: $terms, sort: $sort) {
      nodes {
        ...DomainFragmentForDownloadTags
      }

      totalCount
    }
  }
`
